import type { OverviewPayload } from '../api/types';

/**
 * Slices one chain-wide OverviewPayload down to a single store's view —
 * the exact logic Overview.tsx (Resumen) already used inline for its own
 * store filter, extracted so JCD-17 phase 3's per-widget store filter can
 * reuse it instead of re-deriving the by_store merge.
 *
 * `sid === null` = chain-wide, returns `data` unchanged. A store with no
 * `by_store` slice (older bi_export.p, or none at all) keeps the chain-wide
 * kpis/sales_today/top_parts/top_customers — callers show a "chain-wide"
 * notice the same way Overview.tsx does, by checking `by_store` themselves.
 */
export function sliceOverviewByStore(data: OverviewPayload, sid: number | null): OverviewPayload {
  if (sid === null) return data;
  const storeSlice = data.by_store?.find((b) => b.sid === sid);
  return {
    ...data,
    ...(storeSlice
      ? {
          kpis: { ...data.kpis, ...storeSlice.kpis },
          sales_today: storeSlice.sales_today,
          top_parts: storeSlice.top_parts,
          top_customers: storeSlice.top_customers,
        }
      : {}),
    low_stock: data.low_stock.filter((r) => r.sid === sid),
    slow_movers: data.slow_movers.filter((r) => r.sid === sid),
    sales_by_store: data.sales_by_store.filter((r) => r.sid === sid),
  };
}
